import {
  bigQueryDateWindow,
  isWithinBigQueryDateWindow,
} from "../../dateUtils";

/**
 * Import-facing view of the BigQuery streaming date window.
 *
 * The window itself (and why it exists) lives in `src/utilities/dateUtils.js`;
 * this module only owns the wording an import row needs. Imports are where the
 * constraint bites hardest: a typo'd `1/1/01` parses as 2001-01-01 under
 * dayjs's two-digit-year pivot, and a whole file can carry it.
 */

/**
 * True when a parsed row date falls inside the window. An absent or
 * unparseable date returns true — the "could not parse this date" handling
 * owns that case.
 *
 * @param {Object|Date|string|null} date - dayjs object, Date, or date string
 * @return {boolean}
 */
export const isDateWithinImportWindow = isWithinBigQueryDateWindow;

/** The message to show for a row whose date is outside the window. */
export const importDateWindowMessage = () => {
  const { min, max } = bigQueryDateWindow();
  return `Date must be between ${min.format("MM/DD/YYYY")} and ${max.format("MM/DD/YYYY")} — check for a mistyped year`;
};
